import block1 from '../assets/block1.webp'
import { BONUS_PERCENT } from '../config/scoring.ts'
import { t, tx } from '../i18n/translations.ts'

interface Props {
  message: string
  playerColor: 'black' | 'white'
}

// ゲーム開始前の先手後手確定演出。
// 先手は常に black（エンジン対称性のため）。プレイヤーが black なら先手、white なら後手。
export function IntroOverlay({ message, playerColor }: Props) {
  const playerIsFirst = playerColor === 'black'
  // 先手の駒アイコン（色固定: black=block1 青系 / white=block2 赤系）
  const firstIcon = block1
  const subtext = playerIsFirst
    ? t('playerFirst')
    : tx('playerSecond', { bonus: BONUS_PERCENT })

  return (
    <div className="intro-overlay">
      <div className="intro-overlay__card">
        <img src={firstIcon} alt={t('firstPlayerAlt')} className="intro-overlay__piece" />
        <div className="intro-overlay__title">{message}</div>
        <div className="intro-overlay__sub">{subtext}</div>
      </div>
    </div>
  )
}
